import { useModalContext } from '../ModalNext'

/**
 * Returns the current `value` for the parent `<AlertModalContext>`, if any.
 */
const useAlertModalContext = useModalContext

export { useAlertModalContext }
